module.exports = __webpack_public_path__ + "img/Origine_UE.4d63248a.png";